const MimeTypeImageBmp = "image/bmp";
const MimeTypeImageJpeg = "image/jpeg";
const MimeTypeImagePng = "image/png";
const MimeTypeImageGif = "image/gif";
const MimeTypeTextPlain = "text/plain";
const MimeTypeMsExcel = "application/excel";
const MimeTypeMsPowerpoint = "application/mspowerpoint";
const MimeTypeMpeg = "audio/mpeg";
const MimeTypeWma = "audio/x-ms-wma";
const MimeTypeWav = "audio/x-wav";
const MimeTypeMsVideo = "video/x-msvideo";
const MimeTypeVideoMp4 = "video/mp4";
const MimeTypeVideoQuickTime = "video/quicktime";
const MimeTypeTextCsv = "text/csv";
const MimeTypeMsWord = "application/msword";
const MimeTypeDocx =
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
const MimeTypeTextHtml = "text/html";
const MimeTypePdf = "application/pdf";
const MimeTypeZip = "application/zip";

export const isImageMimeType = (mimeType: string) => {
  return [
    MimeTypeImageBmp,
    MimeTypeImageJpeg,
    MimeTypeImagePng,
    MimeTypeImageGif,
  ].includes(mimeType);
};

export const iconForMimeType = (mimeType: string) => {
  switch (mimeType) {
    case MimeTypeImageBmp:
      return "icon-p24-file-bmp";
    case MimeTypeImageGif:
      return "icon-p24-file-gif";
    case MimeTypeImageJpeg:
      return "icon-p24-file-fpg";
    case MimeTypeImagePng:
      return "icon-p24-file-png";
    case MimeTypeVideoQuickTime:
    case MimeTypeMsVideo:
    case MimeTypeMpeg:
    case MimeTypeVideoMp4:
      return "icon-p24-file-video";
    case MimeTypeWav:
    case MimeTypeWma:
      return "icon-p24-file-sound";
    case MimeTypeMsExcel:
      return "icon-p24-file-xls";
    case MimeTypeMsPowerpoint:
      return "icon-p24-file-pptx";
    case MimeTypeMsWord:
    case MimeTypeTextPlain:
    case MimeTypeDocx:
      return "icon-p24-file-doc";
    case MimeTypeTextCsv:
      return "icon-p24-file-csv";
    case MimeTypeTextHtml:
      return "icon-p24-file-xml";
    case MimeTypePdf:
      return "icon-p24-file-pdf";
    case MimeTypeZip:
      return "icon-p24-file-zip";
    default:
      return "icon-p24-file1";
  }
};
